import { useState, useEffect, useMemo } from 'react';
import { getCategoryV1, getActionsV1 } from '../../../utils/requests';

interface CategoryItem {
  category_ID: string;
  category_Name_TH: string;
  category_Name_EN: string;
  category_Name_CN: string;
  category_Desc: string | null;
  category_Status: string;
  category_Sort: string;
  type: string;
}

interface ActionItem {
  id: string;
  action: string;
}

export const useApiData = (locale: string) => {
  const [categoryData, setCategoryData] = useState<CategoryItem[]>([]);
  const [actionsData, setActionsData] = useState<ActionItem[]>([]);

  const fetchCategoryAndActions = async () => {
    try {
      const categoryResponse = await getCategoryV1();
      
      if (categoryResponse && categoryResponse.data) {
        setCategoryData(categoryResponse.data);
      }
      
      const actionsResponse = await getActionsV1(locale);
      
      if (actionsResponse && actionsResponse.data) {
        setActionsData(actionsResponse.data);
      }
    } catch (error) {
    }
  };
  
  useEffect(() => {
    fetchCategoryAndActions();
  }, [locale]);

  const filteredActions = useMemo(() => {
    if (actionsData && actionsData.length > 0) {
      return actionsData;
    }
    
    return [];
  }, [actionsData]);

  const actionMapping = useMemo(() => {
    const mapping: Record<string, string> = {};
    
    if (actionsData && actionsData.length > 0) {
      actionsData.forEach(action => {
        const actionId = String(action.id);
        const actionName = action.action;
        mapping[actionId] = actionName;
      });
    }
    
    return mapping;
  }, [actionsData]);

  const filteredCategories = useMemo(() => {
    if (categoryData && categoryData.length > 0) {
      return categoryData;
    }
    
    return [];
  }, [categoryData]);

  const categoryMapping = useMemo(() => {
    const mapping: Record<string, string> = {};
    
    if (categoryData && categoryData.length > 0) {
      categoryData.forEach(category => {
        const categoryId = String(category.category_ID);
        
        let categoryName = '';
        if (locale === 'en') {
          categoryName = category.category_Name_EN;
        } else if (locale === 'cn') {
          categoryName = category.category_Name_CN;
        } else {
          categoryName = category.category_Name_TH;
        }
        
        mapping[categoryId] = categoryName;
      });
    }
    
    return mapping;
  }, [categoryData, locale]);

  return {
    categoryData,
    actionsData,
    filteredActions,
    actionMapping,
    filteredCategories,
    categoryMapping
  };
}; 